import { axios } from "../../../lib/axios";

export const deleteChargeSource = async (id: number) => {
  try {
    const response = await axios.delete(`/chargeSource/${id}`);
    return response;
  } catch (error) {
    console.error("Error fetching users:", error);
    throw new Error("Error fetching users: " + error);
  }
};
